import { useEffect, useState } from 'react';

import { get } from '../../../redux/api';
import type { GetInviteTokenResponse } from '../../../../typings/api';

type UseInviteToken = GetInviteTokenResponse;

/**
 * Accepts an invite token and handles fetching the org title
 * for that invite token, to display on the registration page.
 *
 * @param {(alert: string) => void} setAlert - A function to display an alert in case of an error.
 * @param {string} [inviteToken] - Invite token, taken from the query params (so may be undefined).
 */
export default function useInviteToken(setAlert: (alert: string) => void, inviteToken?: string): UseInviteToken {
  const [tokenInfo, setTokenInfo] = useState<UseInviteToken>({ orgTitle: null, invitedEmail: null });
  useEffect(() => {
    async function getInviteToken() {
      if (inviteToken) {
        try {
          const { data } = await get<GetInviteTokenResponse>(`/api/invite-tokens/${inviteToken}`);
          setTokenInfo({
            orgTitle: data?.orgTitle || null,
            invitedEmail: data?.invitedEmail || null,
          });
        } catch (requestError) {
          //  Handle cases where the token is expired, and tell the user that.
          setAlert(requestError.data.message);
        }
      }
    }
    getInviteToken();
  }, [setAlert, inviteToken]);

  return tokenInfo;
}
